const contact = function()
{

  var token = document.querySelector('meta[name="csrf"]').content;
  var items = document.querySelectorAll('.js--form')

  
  items.forEach(el => {
    el.addEventListener('submit', send);
  });

  function send(e) {
    e.preventDefault();
    var that = this;

    var formData = new FormData(this);


    var data = new FormData();

    data.append('type', 'Support Request');
    data.append('from[name]', formData.get('name'));
    data.append('from[email]',  formData.get('email'));
    data.append('mail[body]', formData.get('message'));
    data.append('mail[subject]', 'Support Request');

    
    if( !validateEmail(formData.get('email')) ) {
      fail(that, 'Invalid email address');
      return;
    }


    var req = new XMLHttpRequest();
    req.open("POST", '/home/mail/contact');
    req.setRequestHeader('X-CSRF-TOKEN', token);
    req.onreadystatechange = function() {
      if (this.readyState == 4 && this.status == 200) {
        try{
          var data = JSON.parse(this.response)
        } catch(e){
          console.log('wrong json');
          fail(that);
          return;
        }

        if(data.state == 'ok') {
          success(that);
        } else {
          fail(that, data.response);
        }
        
      } else if(this.readyState ==4 && this.status == 500) {
        fail(that);
      }
    }

    req.send(data);


    
  }

  function success(form) {
    clearForm(form);
    try{
      form.querySelector('.form__result').remove()
    } catch(e){};
    var div = document.createElement('div');
    div.className = "form__result form__result--success";
    div.innerText = 'Ticket Submitted Successfully!';
    form.appendChild(div);
  }

  function fail(form, text) {
    try{
      form.querySelector('.form__result').remove()
    } catch(e){};
    var div = document.createElement('div');
    div.className = "form__result form__result--fail";
    if(text) {
      div.innerHTML = text;
    } else {
      div.innerHTML = 'Unknown error. Please contact via <a href="mailto:support@tubecorporate.com">email</a>';
    }
    form.appendChild(div);
  }

  function clearForm(form) {
    var items = form.querySelectorAll('input, textarea');
    items.forEach(el => {
      el.value = '';
    });
    
  }


  function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  
}

export default contact;


